/**
 * FeedbackQuestionType
 */
export enum FeedbackQuestionType {
    SINGLE_SELECTION = 'single_selection',
    MULTI_SELECTION = 'multi_selection',
    SLIDER = 'slider',
    RATING = 'rating',
    TEXT_INPUT = 'text_input',
    DROPDOWN = 'dropdown',
    ORDERING = 'ordering',
    DATE_TIME = 'date_time',
    TIME = 'time',
    DATE = 'date',
    FILES = 'files'
}
